import axios from 'axios';
import { getIdTokenLocalStorage } from '@catapultxos/sso-auth';

export const idmApi = axios.create({
  baseURL: process.env.REACT_APP_IDM_API_URL,
});

idmApi.interceptors.request.use((config) => {
  const token = getIdTokenLocalStorage();
  // eslint-disable-next-line no-param-reassign
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
});
